export default __webpack_public_path__ + "static/media/huatai.732219b7.png";